import { FolderInfo, LabelOverride } from '../types';

// PandaAI Email label customisation (rename / colour / delete) layered over the Gmail/IMAP label
// mirror. Purely local — nothing here is ever written back to the mail server.

// Preset colours offered in the Edit label dialog (any other colour can be picked as well).
export const LABEL_COLORS = [
  '#E24B4A', '#D85A30', '#BA7517', '#B7950B', '#1D9E75', '#2F855A',
  '#378ADD', '#2B6CB0', '#7F77DD', '#6D28D9', '#C2417B', '#6B7280',
];

// Bangkok time to the minute, for the who/when line under a changed or deleted label.
export const fmtLabelStamp = (ts?: number) => ts
  ? new Date(ts * 1000).toLocaleString('en-GB', { timeZone: 'Asia/Bangkok', day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false })
  : '';

// Parent paths of a label ('A/B/C' → 'A', 'A/B').
function parentPaths(f: FolderInfo): string[] {
  const d = f.delimiter || '/';
  const segs = f.path.split(d);
  return segs.slice(0, -1).map((_, i) => segs.slice(0, i + 1).join(d));
}

// How PandaAI Email shows one label. `deleted` = this label was deleted here; `hidden` = it or a
// label it is nested under was (deleting a parent takes its sub-labels out of the list with it).
export function labelView(f: FolderInfo, overrides?: Record<string, LabelOverride>) {
  const o = overrides?.[f.path];
  return {
    name: o?.name || f.name,
    color: o?.color || '',
    deleted: !!o?.deleted,
    hidden: !!o?.deleted || parentPaths(f).some(p => !!overrides?.[p]?.deleted),
  };
}
